import { Color, Text } from '@billy/design-system'
import React, { ReactElement } from 'react'

import { getClassName } from '../../../../utils/getClassName'
import { FullScreenOverlay } from '../../FullScreenOverlay'
import * as Styled from './styles'

export interface AppLoadingScreenProps {
  text: string
}
export const AppLoadingScreen = ({ text }: AppLoadingScreenProps): ReactElement => {
  return (
    <FullScreenOverlay bgColor={Color.Orange50} className={getClassName('app-loading-screen')}>
      <Styled.Logo logo="logoSimpleSvg" color={Color.Green950} />
      <Text alignment="center" color={Color.Black}>
        {text}
      </Text>
    </FullScreenOverlay>
  )
}
